export default {
    label_task:{
        en:"Distributors Stock Report",
        bn:'Variety Report'
    },
    label_fiscal_year :{
        en:"Fiscal Year",
        bn:'ব্যবহারকারীরা'
    },
    label_target_quantity :{
        en:"Target",
        bn:'ব্যবহারকারীরা'
    },
    label_sales_quantity :{
        en:"Sales (cumulative)",
        bn:'ব্যবহারকারীরা'
    },
    label_balance_quantity:{
        en:"Balance (cumulative)",
        bn:'ব্যবহারকারীরা'
    },
    label_stock_open_quantity:{
        en:"Opening Stock",
        bn:'ব্যবহারকারীরা'
    },

    label_stock_purchase_quantity :{
        en:"Purchase",
        bn:'ব্যবহারকারীরা'
    },
    label_stock_sales_quantity:{
        en:"Sales",
        bn:"কর্মচারী আইডি"
    },
    label_stock_end_quantity:{
        en:"Balance (quantity)",
        bn:"কর্মচারী আইডি"
    },
    label_stock_end_amount:{
        en:"Balance (amount)",
        bn:"কর্মচারী আইডি"
    },
    label_month_status:{
        en:"Season Status",
        bn:'Variety Report'
    },
    label_stock_status:{
        en:"Stock Status",
        bn:'Variety Report'
    },
}